import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Google
 * id 3703C79F-7F34-41D6-A12F-6247144FEB02
 * name calendar-outline
 * version: 3.0.39
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/calendar-outline.svg
 * tags
 * - Date / Time 
 */
export const CalendarOutlineIcon = createSvgIcon(<><path d="M12 12H17V17H12V12M19 3H18V1H16V3H8V1H6V3H5C3.9 3 3 3.9 3 5V19C3 20.1 3.9 21 5 21H19C20.1 21 21 20.1 21 19V5C21 3.9 20.1 3 19 3M19 5V7H5V5H19M5 19V9H19V19H5Z" /></>, 'CalendarOutlineIcon');
export default CalendarOutlineIcon